export { SubstanceDetailSegment as default } from './SubstanceDetailSegment'
export {
  SubstanceTitleSegment,
  SubstanceInfoSegment,
} from './SubstanceDetailSegment'
